module.exports = __webpack_public_path__ + "static/media/baxi-logo-white.e67ff119.jpg";